module.exports = __webpack_public_path__ + "assets/img/discernment_age_describe.d42d39c3.png";